import { formatData, sortByDate, sortByDateReverse } from "./utils";

export function getPayments(){
    console.log("getPayments : Start")
    return async function (dispatch){
        dispatch({ type: "FETCH_PAYMENTS_START", payload: "" })
        try {

            const req = await fetch('/money/ca/global/info', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ////'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getPayments res : ', res);
            // check err !
            let payments_list = res.resp ? sortByDate(res.resp, "timePayment") : {}
            
            const formated_payments_list = formatData(payments_list, "paymentID")
            console.log('getPayments res :  formated_payments_list ', formated_payments_list);

            // const formated_payments_list = formatData(payments_list, "timePayment")
            dispatch({
                type: "GET_PAYMENTS",
                payload: formated_payments_list
            })

            dispatch({
                type: "GET_ALL_CLIENTS_PAYMENTS",
                payload: payments_list
            })
            dispatch({ type: "FETCH_PAYMENTS_FULFILLED", payload: "" }) 

        } catch (error) {
            console.log("[ERROR] get payments list : ", error);
            dispatch({ type: "FETCH_PAYMENTS_ERROR", payload: error })
        }
         
    }
}
export function getPaymentsNEW(timeFrom,timeTo,boxAssoId){
    console.log("getPaymentsNEW : Start")
    return async function (dispatch){
        dispatch({ type: "FETCH_PAYMENTS_START", payload: "" })
        try {

            const req = await fetch('/money/payment/list', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    boxAssoID:boxAssoId,
                    from:timeFrom.toISOString(),
                    to:timeTo.toISOString(),
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getPaymentsNEW res : ', res);
            // check err - ensure we always have an array (res.resp can be object on error, or undefined)
            let payments_list = Array.isArray(res.resp) ? sortByDate(res.resp, "timePayment") : [];
            
            const formated_payments_list = formatData(payments_list, "paymentID")
            console.log('getPaymentsNEW res :  formated_payments_list ', formated_payments_list);

            // const formated_payments_list = formatData(payments_list, "timePayment")
            dispatch({
                type: "GET_PAYMENTS",
                payload: formated_payments_list
            })

            dispatch({
                type: "GET_ALL_CLIENTS_PAYMENTS",
                payload: payments_list
            })
            dispatch({ type: "FETCH_PAYMENTS_FULFILLED", payload: "" }) 

        } catch (error) {
            console.log("[ERROR] getPaymentsNEW list : ", error);
            dispatch({ type: "FETCH_PAYMENTS_ERROR", payload: error })
        }
         
    }
}
export function getIncomeInfo(incomeID){
    return async function (dispatch){
        dispatch({ type: "GET_INCOME_START", payload: "" })
        try {
            const req = await fetch('/money/get/income/info', {
                method: 'POST',
                body: JSON.stringify({incomeID}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getIncomeInfo res : ', res);
            dispatch({ type: "GET_INCOME_FULFILLED", payload: "" }) 
            return res
            
        } catch (error) {
            console.log("[ERROR] get income info compta : ", error);
            dispatch({ type: "GET_INCOME_ERROR", payload: error.message })
            return {error: error.message}
        }
    }
}
export function getPaymentSmsInfo(paymentID){
    return async function (dispatch){
        try {
            const req = await fetch(`/money/payment/${encodeURIComponent(paymentID)}/sms`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            return res;
        } catch (error) {
            console.log("[ERROR] getPaymentSmsInfo : ", error);
            return {error: error.message};
        }
    }
}
export function getSpendingInfo(spendingID){
    return async function (dispatch){
        dispatch({ type: "GET_INCOME_START", payload: "" })
        try {
            const req = await fetch('/money/get/spending/info', {
                method: 'POST',
                body: JSON.stringify({spendingID}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('getSpendingInfo res : ', res);
            dispatch({ type: "GET_INCOME_FULFILLED", payload: "" }) 
            return res
            
        } catch (error) {
            console.log("[ERROR] get spending info compta : ", error);
            dispatch({ type: "GET_INCOME_ERROR", payload: error.message })
            return {error: error.message}
        }
    }
}
export function linkPaymentsTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            // Un seul appel : le serveur enchaîne le 8000 puis la comptabilité 5000 et rétablit
            // l'état antérieur si le second n'aboutit pas. L'enchaînement était fait ici, depuis
            // le navigateur, sans garantie que le second appel parte.
            const req = await fetch('/stocks/compta/paygo/link', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            const res = await req.json();

            if (res.error) {
                dispatch({ type: "LINK_PAYMENTS_ERROR", payload: res.error })
                // Le résultat est rendu à l'appelant : lire l'erreur dans le store juste après l'await
                // renverrait la valeur capturée au rendu précédent, et l'écran annoncerait un succès.
                return { ok: false, error: res.error }
            }
            // Montants réellement rattachés, par paiement, tels que rendus par le serveur ; à défaut
            // ceux demandés. Le store est indexé par paymentID : payments porte ces clés.
            dispatch({
                type: "UPDATE_PAYMENTS_LINK",
                payload: {list: data.payments, income_id: data.income_id, amounts: res.payments || data.amounts || {}}
            })
            dispatch({ type: "LINK_PAYMENTS_FULFILLED", payload: "" })

            return { ok: true }
        } catch (error) {
            console.log("[ERROR] rapprochement 5000 : ", error);
            dispatch({ type: "LINK_PAYMENTS_ERROR", payload: error.message })
        }
    }
}
export function unLinkPaymentsTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            // Un seul appel : le serveur enchaîne le 8000 puis la comptabilité 5000 et rétablit
            // l'état antérieur si le second n'aboutit pas. L'enchaînement était fait ici, depuis
            // le navigateur, sans garantie que le second appel parte.
            const req = await fetch('/stocks/compta/paygo/unlink', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            const res = await req.json();

            if (res.error) {
                dispatch({ type: "LINK_PAYMENTS_ERROR", payload: res.error })
                // Le résultat est rendu à l'appelant : lire l'erreur dans le store juste après l'await
                // renverrait la valeur capturée au rendu précédent, et l'écran annoncerait un succès.
                return { ok: false, error: res.error }
            }
            // Seul le lien vers income_id est retiré, du montant rendu par le serveur ; sans montant,
            // le lien entier.
            dispatch({
                type: "UPDATE_PAYMENTS_UNLINK",
                payload: {list: data.payments, income_id: data.income_id, amounts: res.payments || data.amounts || {}}
            })
            dispatch({ type: "LINK_PAYMENTS_FULFILLED", payload: "" })

            return { ok: true }
        } catch (error) {
            console.log("[ERROR] rapprochement 5000 : ", error);
            dispatch({ type: "LINK_PAYMENTS_ERROR", payload: error.message })
        }
    }
}
